// extracted by mini-css-extract-plugin
export var chevron = "_h2-4";
export var chevronExpanded = "_h2-5";
export var row = "_h2-0";
export var rowBody = "_h2-6";
export var rowDescription = "_h2-7";
export var rowHeader = "_h2-1";
export var rowTitle = "_h2-2";
export var rowTitleComplete = "_h2-3";